import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlobeRegularSearchIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 12.875c.054 0 .162-.027.303-.126a3.14 3.14 0 0 0 1.986.797 6 6 0 1 1 3.257-3.257 3.15 3.15 0 0 0-2.074-2.851h1.37a4.89 4.89 0 0 0-2.878-3.9c.546.973.922 2.316 1.014 3.765a3.2 3.2 0 0 0-1.128-.005c-.082-1.15-.36-2.2-.744-2.978C8.602 3.296 8.136 3.125 8 3.125s-.602.171-1.106 1.195c-.396.807-.682 1.91-.753 3.117h3.185a3.16 3.16 0 0 0-1.485 1.125h-1.7c.068 1.205.354 2.31.753 3.118.504 1.024.97 1.195 1.106 1.195M3.158 7.438h1.856c.077-1.5.46-2.897 1.022-3.9a4.88 4.88 0 0 0-2.878 3.9m1.856 1.125H3.158a4.89 4.89 0 0 0 2.878 3.9c-.563-1.004-.945-2.4-1.022-3.9"
	}), /* @__PURE__ */ _jsx("path", { d: "M10.451 8a2.451 2.451 0 0 1 2.043 3.801l1.362 1.363a.49.49 0 1 1-.693.693l-1.361-1.362A2.45 2.45 0 1 1 10.452 8m0 .98a1.47 1.47 0 1 0 0 2.942 1.47 1.47 0 0 0 0-2.942" })]
});
export default SvgGlobeRegularSearchIcon;
